<template>
<div class="numCardDataList">
    <!-- 标题 -->
    <div class="titleBox flex-row ite-c jus-b">
        <div>
            <b>{{topTitle.title}}</b><span v-show="topTitle.subTit!==''"> - {{topTitle.subTit}}</span>
        </div>
        <div class="exportBtn butStyle" @click="exportData">导出</div>
    </div>

    <!-- 筛选条件 -->
    <div class="searchBox flex-row ite-c jus-b boxs">
        <ul class="colList boxs">
            <li>
                <span class="col-tit2">代理商</span>
                <el-input v-model="currentMember" class="memberInput" readonly></el-input> - 
                <el-select v-model="agentsForm.agent1" clearable filterable placeholder="请选择代理商" @change="agentChange">
                    <el-option v-for="item in agentsForm.agentOptions1" :key="item.id" :label="item.name" :value="item.id"></el-option>
                </el-select>

                <div v-if="agentsForm.agentOptions2.length>0 && agentsForm.agent1" class="agentSelect"> -
                    <el-select v-model="agentsForm.agent2" clearable filterable placeholder="请选择下一级代理商" @change="agentChange2">
                    <el-option v-for="item in agentsForm.agentOptions2" :key="item.id" :label="item.name" :value="item.id"></el-option>
                    </el-select>
                </div>
                <div v-if="agentsForm.agentOptions3.length>0 && agentsForm.agent2" class="agentSelect"> -
                    <el-select v-model="agentsForm.agent3" clearable filterable placeholder="请选择下二级代理商" @change="agentChange3">
                    <el-option v-for="item in agentsForm.agentOptions3" :key="item.id" :label="item.name" :value="item.id"></el-option>
                    </el-select>
                </div>
                <div v-if="agentsForm.agentOptions4.length>0 && agentsForm.agent3" class="agentSelect"> -
                    <el-select v-model="agentsForm.agent4" clearable filterable placeholder="请选择下三级代理商" @change="agentChange4">
                    <el-option v-for="item in agentsForm.agentOptions4" :key="item.id" :label="item.name" :value="item.id"></el-option>
                    </el-select>
                </div>
            </li>
            <li>
              <el-checkbox v-model="isSelf" @change="isSelfChange">是否仅查自营</el-checkbox>
            </li>
        </ul>
        <div class="ri-box">
            <button @click="handleSearch" class="butStyle greenBtn searchBtn">
                <i class="el-icon-search"></i>
            </button>
        </div>
    </div>


    <!-- 统计数量 -->
    <ul class="totalBox boxs">
        <li>
          <p class="tbTit">号卡总量</p>
          <p class="tbTotal">{{numCardTotal}}</p>
        </li>
        <li>
          <p class="tbTit">可激活总数</p>
          <p class="tbTotal">{{activableNum}}</p>
        </li>
        <li>
          <p class="tbTit">已激活总数</p>
          <p class="tbTotal">{{activatedNum}}</p>
        </li>
        <li>
          <p class="tbTit">已停机总数</p>
          <p class="tbTotal">{{outageNum}}</p>
        </li>
        <li>
          <p class="tbTit">本月到期</p>
          <p class="tbTotal">{{thisMonthExpires}}</p>
        </li>
    </ul>


    <!-- 数据列表 -->
    <div class="ListBox tableTheadGray boxs">
        <el-table ref="multipleTable" :data="tableData" style="width: 100%" border fit tooltip-effect="dark">
            <el-table-column  min-width="160" prop="member_name" label="运营商名称" header-align="center" align="center" show-overflow-tooltip></el-table-column>
            <el-table-column  min-width="120" prop="allNumberNum" label="号卡总数" header-align="center" align="center" show-overflow-tooltip></el-table-column>
            <el-table-column  min-width="120" prop="noActiveNum" label="可激活数" header-align="center" align="center" show-overflow-tooltip></el-table-column>
            <el-table-column  min-width="120" prop="isActiveNum" label="已激活数" header-align="center" align="center" show-overflow-tooltip></el-table-column>
            <el-table-column  min-width="120" prop="isStopNum" label="已停机数" header-align="center" align="center" show-overflow-tooltip></el-table-column>
            <el-table-column  min-width="120" prop="isExpireNum" label="本月到期数" header-align="center" align="center" show-overflow-tooltip></el-table-column>
        </el-table>
        <div class="pageBox boxs">
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="searchForm.page" :page-sizes="[10, 20, 30]" :page-size="searchForm.size" layout="total, sizes, prev, pager, next, jumper" :total="total">
            </el-pagination>
        </div>
    </div>


</div>
</template>

<script>
import {
    getNumCardDetailStatusReq, // 获取号码多种状态数量(详情页面)
    getNumCardDetailReq, //  获取号码统计详情(详情页面)
    uploadNumCardDetailReq, // 号码统计详情导出(详情页面)
    getAgentsMap, // 获取指定会员的下一级代理商
} from '@/api/Report/Watch/dataReport.js';
import {objectToQueryString} from '@/utils/commonUtils.js';
// 搜索表单的数据
const searchConst = {
    business_type: null,
    member_id: null,
    self_support: 2,//是否仅查自营：1:是，2:否
    page: 1, //当前页码
    size: 10, //每页条数
}
// 查询代理商数据
const defaultAgentsForm = {
    agent1: null, //代理商
    agent2: null, //代理商2
    agent3: null, //代理商3
    agent4: null, //代理商4
    agentOptions1: [],//代理商数组
    agentOptions2: [],//代理商数组2
    agentOptions3: [],//代理商数组3
    agentOptions4: [],//代理商数组4
}

export default {
    name: 'numCardDataList',
    data() {
        return {
            //标题
            topTitle: {
                title: '',
                subTit: '号卡统计数据列表'
            },

            // 当前代理商
            currentMember: null,
            currentMemberId: null,
            // 查询代理商数据
            agentsForm: Object.assign({}, defaultAgentsForm),
            isSelf: false, //是否自营
            // 搜索条件
            searchForm: Object.assign({}, searchConst),

            // 号卡统计
            numCardTotal: 0, //号卡总数
            activableNum: 0, //可激活数
            activatedNum: 0, //已激活数
            outageNum: 0, //已停机数
            thisMonthExpires: 0, //本月到期

            // 数据列表
            tableData: [], // 表格数据
            total: 0, // 表格数据总数

        }
    },
    mounted() {},
    created () {
        // 获取下一级代理商
        this.initAgentOption();

        // 获取上级页面携带的参数，获取表格数据
        this.initNumCardDataList()
    },
    methods: {
        // 获取上级页面携带的参数，获取表格数据
        initNumCardDataList () {
            console.log('this.$route.query',this.$route.query)
            this.searchForm.member_id = this.$route.query.member_id;
            this.currentMemberId = this.$route.query.member_id;
            this.searchForm.business_type = parseInt(this.$route.query.business_type);
            this.topTitle.title = this.$route.query.title;
            this.searchForm.self_support = parseInt(this.$route.query.self_support);
            if(!this.$route.query.member_id) {
                this.currentMember = this.$route.query.currentMember;
            }else{
                this.currentMember = this.$route.query.member_name
            }
            if(this.searchForm.self_support == 1) {
                this.isSelf = true
            } else if (this.searchForm.self_support == 2) {
                this.isSelf = false
            }

            // 获取号码多种状态数量(详情页面)
            this.getNumCardDetailStatus()

            getNumCardDetailReq(this.searchForm)
                .then(resp => {
                    this.tableData = resp.body.rows
                    this.total = parseInt(resp.body.total)
                })
                .catch(e => console.log(e))
        
        },
        // 获取上级页面携带的参数，获取表格数据
        searchNumCardDataList () {
            this.searchForm.business_type = parseInt(this.$route.query.business_type);
            this.topTitle.title = this.$route.query.title;

            // 获取号码多种状态数量(详情页面)
            this.getNumCardDetailStatus()

            getNumCardDetailReq(this.searchForm)
                .then(resp => {
                    this.tableData = resp.body.rows
                    this.total = parseInt(resp.body.total)
                })
                .catch(e => console.log(e))
        
        },
        // 获取号码多种状态数量(详情页面)
        getNumCardDetailStatus() {
            getNumCardDetailStatusReq(this.searchForm)
                .then(resp => {
                    // 号卡总数
                    this.numCardTotal = resp.body.allNumberNum
                    // 可激活数
                    this.activableNum = resp.body.noActiveNum
                    // 已激活数
                    this.activatedNum = resp.body.isActiveNum
                    // 已停机数
                    this.outageNum = resp.body.isStopNum
                    // 本月到期
                    this.thisMonthExpires = resp.body.isExpireNum
                })
                .catch(e => console.log(e))
        },
        // 切换是否自营
        isSelfChange() {
            if(this.isSelf == true){
                this.searchForm.self_support = 1
            } else if (this.isSelf == false) {
                this.searchForm.self_support = 2
            }
        },
        // 列表过滤查询
        handleSearch () {
            this.searchForm.page = 1
            this.searchNumCardDataList()
        },
        // 列表每页条数变了
        handleSizeChange (val) {
            this.searchForm.size = val
            this.searchNumCardDataList()
        },
        // 列表当前页码变了
        handleCurrentChange (val) {
            this.searchForm.page = val
            this.searchNumCardDataList()
        },

        // 导出
        exportData() {
            let exportParam = {
                business_type: this.searchForm.business_type,
                member_id: this.searchForm.member_id,
                self_support: this.searchForm.self_support
            }
            var url = `${this.$baseUrl}/!Rpt/Watch/DataReport/~java/NumberCardStatistics.getMultipleStatusDetailExport?${objectToQueryString(exportParam)}`;
            console.log(url);
            window.open(url, '_blank');
        },

        // 获取下一级代理商
        initAgentOption() {
            getAgentsMap(this.searchForm).then(res => {
                if (!res || res.length <= 0) {
                    return;
                }
                this.agentsForm.agentOptions1 = res;
                // var rows = unescape(JSON.stringify(res.body));
                // this.agentsForm.agentOptions1 = JSON.parse(rows);
            }).catch(err => {
                console.log(err)
            })
        },
        // 切换代理商
        agentChange() {
            this.agentsForm.agentOptions2 = []
            if(!this.agentsForm.agent1){
                // 第1个代理商为空时，全局代理商=当前登录会员的memberId
                this.searchForm.member_id = this.currentMemberId;
                // console.log('第一个为空')
                // console.log('第一个为空this.searchForm.member_id',this.searchForm.member_id)
            } else {
                this.searchForm.member_id = this.agentsForm.agent1;
                // console.log('第一个不为空')
                // console.log('第一个不为空this.searchForm.member_id',this.searchForm.member_id)
            }

            getAgentsMap(this.searchForm).then(res => {
                if (!res || res.length <= 0) {
                    return;
                }
                this.agentsForm.agentOptions2 = res;
            }).catch(err => {
                console.log(err)
            })
        },
        // 切换代理商2
        agentChange2() {
            this.agentsForm.agentOptions3 = []
            if(!this.agentsForm.agent2){
                // 第2个代理商为空时，全局代理商=第1个代理商
                this.searchForm.member_id = this.agentsForm.agent1;
            } else {
                this.searchForm.member_id = this.agentsForm.agent2;
            }
            // console.log('agentChange-agent2', this.agentsForm.agent2);
            // console.log('agentChange2-search.agent', this.searchForm.member_id)

            getAgentsMap(this.searchForm).then(res => {
                if (!res || res.length <= 0) {
                    return;
                }
                this.agentsForm.agentOptions3 = res;
            }).catch(err => {
                console.log(err)
            })
        },
        // 切换代理商3
        agentChange3() {
            this.agentsForm.agentOptions4 = []
            if(!this.agentsForm.agent3){
                // 第3个代理商为空时，全局代理商=第2个代理商
                this.searchForm.member_id = this.agentsForm.agent2;
            } else {
                this.searchForm.member_id = this.agentsForm.agent3;
            }
            // console.log('agentChange-agent3', this.agentsForm.agent3);
            // console.log('agentChange3-search.agent', this.searchForm.member_id)

            getAgentsMap(this.searchForm).then(res => {
                if (!res || res.length <= 0) {
                    return;
                }
                this.agentsForm.agentOptions4 = res;
            }).catch(err => {
                console.log(err)
            })
        },
        // 切换代理商4
        agentChange4() {
            // this.agentsForm.agentOptions5 = []
            if(!this.agentsForm.agent4){
                // 第4个代理商为空时，全局代理商=第3个代理商
                this.searchForm.member_id = this.agentsForm.agent3;
            } else {
                this.searchForm.member_id = this.agentsForm.agent4;
            }
            // console.log('agentChange-agent4', this.agentsForm.agent4);
            // console.log('agentChange3-search.agent', this.searchForm.member_id)

            // getAgentsMap(this.searchForm).then(res => {
            //     if (!res || res.length <= 0) {
            //         return;
            //     }
            //     this.agentsForm.agentOptions5 = res;
            // }).catch(err => {
            //     console.log(err)
            // })
        },


    },
    
}
</script>

<style scoped>
.marRi20{
    margin-right: 20px;
}
.bgYellow{
    background: #FFC400;
}
.bgBlue{
    background: #1F78B4;
}
.bgLightBlue{
    background: #A6CEE3;
}
.bgLightGreen{
    background: #B2DF8A;
}
.bgGreen{
    background: #1DB56F;
}

.numCardDataList{
    /* width: 100%; */
    min-width: 620px;
}

/* 标题 */
.numCardDataList .titleBox{
     width: 100%;
    background: #ffffff;
    height: 44px;
    padding-left: 9px;
    box-sizing: border-box;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
}
.titleBox b{
    color:#333333;
    font-size: 14px;
}
.titleBox b::before{
    content: '';
    display: inline-block;
    height: 19px;
    width: 6px;
    background: #1DB56F;
    margin-right: 10px;
    vertical-align: middle;
}
.titleBox span{
    color:#7F7F7F;
    font-size: 12px;
}
.titleBox .exportBtn{
    color:#FF2A2A;
    font-size: 14px;
    height: 16px;
}
.titleBox .exportBtn::before{
    content: '';
    display: inline-block;
    height: 16px;
    width: 16px;
    background: url('../../../../../assets/images/report/DataReport/export.png') no-repeat;
    background-size: 16px 16px;
    margin-right: 4px;
    vertical-align: middle;
}


/* 筛选条件 */
.searchBox{
    width: 100%;
    padding: 12px;
    margin-top: 10px;
    background: #fff;
    border: 1px solid #E4E4E4;
}
.searchBox .colList {
    width: calc( 100% - 100px);
}
.searchBox .outInput {
    /* width: 25%; */
    max-width: 200px;
}
.searchBox .memberInput {
    /* width: 25%; */
    max-width: 200px;
}
.searchBox .agentSelect {
    display: inline;
}


/* 统计数量 */
.totalBox{
    width: 100%;
    height: 64px;
    /* margin-top: 14px; */
    margin: 14px 0;
}
.totalBox li{
    float: left;
    width: 200px;
    /* min-width: 19%; */
    height: 64px;
    padding: 12px 10px 7px;
    background: #FFC400;
    color:#FFFFFF;
    box-sizing: border-box;
    -moz-box-sizing: border-box;
    -webkit-box-sizing: border-box;
    border-radius: 5px;
    -o-border-radius: 5px;
    -webkit-border-radius: 5px;
    display: flex;
    flex-flow: column nowrap;
    justify-content: space-between;
}
.totalBox li+li{
    margin-left: 10px;
}
.totalBox li:nth-child(2){
    background: #1F78B4;
}
.totalBox li:nth-child(3){
    background: #A6CEE3;
}
.totalBox li:nth-child(4){
    background: #B2DF8A;
}
.totalBox li:nth-child(5){
    background: #33A02C;
}
.totalBox li .tbTit{
    font-size: 13px;
    height: 17px;
    line-height: 17px;
}
.totalBox li .tbTotal{
    font-size: 20px;
    height: 26px;
    line-height: 26px;
    text-align: end;
}

/* 数据列表 */
.ListBox{
    width: 100%;
}
/* 分页条 */
.pageBox {
    width: 100%;
    padding: 15px 0 10px;
    display: flex;
    justify-content: flex-end;
    background: #ffffff;
    border: 1px solid #E4E4E4;
    border-top: none;
    border-bottom-left-radius: 3px;
    border-bottom-right-radius: 3px;
}
</style>
